module.exports = __webpack_public_path__ + "img/image3.a7fa9ed6.png";